<form [formGroup]="form">
    <kendo-floatinglabel text="Reason for Request for New Document *" class="k-w-full">
        <kendo-textarea formControlName="reason" fillMode="outline" [rows]="5"></kendo-textarea>
    </kendo-floatinglabel>
</form>
<div class="page-footer k-mt-2 k-text-right">
    <div class="action-btns">
        <div class="action-btns__right">
            <button kendoButton fillMode="outline" themeColor="error" size="large" rounded="large" (click)="onCancel()">
                Close
            </button>
            &nbsp;
            <button kendoButton themeColor="primary" (click)="submit()" [disabled]="form.invalid" fillMode="solid"
                size="large" rounded="large">
                Request New Document
            </button>
        </div>
    </div>
</div>